<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
        <template slot="buttons">
          <!-- <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>{{$helper.getWord('save')}}
            </button>
          </div> -->
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="fas fa-caret-right mr-2"></i>{{$helper.getWord('back')}}
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <!-- <DataFilter :gridId="gridId" :isExport="false"></DataFilter> -->
        <SlickGrid
          :gridId="gridId"
          :editable="false"
          :frozenColumn="2"
          :isAutoInitData="true"
          :isModeManager="true"
          :baseUrl="baseUrl"
        />
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Roles",
  access_code: "G_MT03",
  icon: "fas fa-cog fa-fw",
  hidden: true,
  order: 5,
  components: {},
  data() {
    return {
      gridId: "mt03",
      formData: {
        staff_name: ""
      },
      baseUrl:"/system_maintenance"
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
    helper.initGrid(this);
    helper.defaultFilerValue(this.gridId, "role_name", this.$route.params.id);
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },
    mode() {
      return this.grid.mode;
    },
    dataList() {
      return this.grid.data;
    }
  },
  mounted() {},
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),

    cancelBtnClick() {
      this.$router.go(-1);
    },
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>